import { create } from 'zustand'
const useAppStore = create((set) => ({
  isDarkMode: localStorage.getItem('isDarkMode') === 'true' || false,
  toggleDarkMode: () => set((state) => {
    localStorage.setItem('isDarkMode', !state.isDarkMode)
    return { isDarkMode: !state.isDarkMode }
  })
}))

export default useAppStore